import { createI18n } from 'vue-i18n'
import fr from './locales/fr.js'
import en from './locales/en.js'

// Détecter la langue du navigateur
function getDefaultLocale() {
  const browserLang = navigator.language || navigator.userLanguage
  const supportedLocales = ['fr', 'en']
  
  // Vérifier si la langue du navigateur est supportée
  const lang = browserLang.split('-')[0]
  if (supportedLocales.includes(lang)) {
    return lang
  }
  
  // Par défaut, utiliser le français
  return 'fr'
}

// Récupérer la langue sauvegardée ou utiliser la langue par défaut
function getSavedLocale() {
  const saved = localStorage.getItem('locale')
  if (saved && ['fr', 'en'].includes(saved)) {
    return saved
  }
  return getDefaultLocale()
}

const i18n = createI18n({
  legacy: false, // Utiliser la Composition API
  locale: getSavedLocale(),
  fallbackLocale: 'fr',
  messageCompiler: null, 
  messages: {
    fr,
    en
  }
})

// Sauvegarder la langue dans localStorage quand elle change
// Note: watch n'est pas disponible dans Vue I18n v9, on utilise un watcher dans les composants si nécessaire

export default i18n 